<div fxLayout="column" fxFlex fusePerfectScrollbar>
    <ng-container>
        <mat-divider cdkFocusRegionEnd></mat-divider>

        <mat-list>
            <h3 matSubheader fxLayout="row" fxLayoutAlign="space-between center">
                <span>Notificações</span>
                <button mat-icon-button matTooltip="Marcar todas como lidas" aria-label="Marcar todas como lidas"
                    (click)="markAllAsRead()" [disabled]="notifications.length === 0" class="mark-all-button">
                    <mat-icon>done_all</mat-icon>
                </button>
            </h3>

            <mat-list-item (click)="navigateToNotifiable(notification)" class="clickable"
                *ngFor="let notification of notifications">
                <button mat-icon-button class="mark-read-icon" (click)="markAsRead(notification, $event)"
                    matTooltip="Marcar como lida">
                    <svg viewBox="0 0 30 30" width="20" height="20">
                        <circle class="dot-fill" cx="16" cy="16" r="4" />
                        <circle class="dot-outline" cx="16" cy="16" r="12" fill="none" />
                    </svg>
                </button>

                <div matLine class="font-small-strong">
                    {{ notification.notifiableTitle }}
                </div>

                <div matLine class="paragraph">
                    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="secondary-text w-100-p">
                        <p class="message-text mat-body-1">{{notification.message}}</p>
                    </div>
                </div>

                <h3 matLine class="font-small-hours">{{notification.timeElapsed}}</h3>
            </mat-list-item>
        </mat-list>
    </ng-container>
</div>